import React, { FC, memo } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  padding: 10px;
`;

interface Props {
  message: string;
}

export const NotFoundTemplate: FC<Props> = memo(
  ({ message }: Readonly<Props>) => <Root>{message}</Root>
);

NotFoundTemplate.displayName = 'NotFoundTemplate';
